import React, { useState } from 'react';
import { message, Button, Select, Tag } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { t } from '../../i18n/i18n';

const EmailTagsInput = ({ emails = [], setEmails = () => {}, suggestions = [], placeholder }) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const [searchValue, setSearchValue] = useState('');

  const handleEmailChange = (value) => {
    const validEmails = value.filter((email) => emailRegex.test(email));
    const invalidEmails = value.filter((email) => !emailRegex.test(email));

    if (invalidEmails.length > 0) {
      message.error(t('EMAIL_INVALID'));
    }

    setEmails(validEmails);
    setSearchValue('');
  };

  const handleClearAll = () => {
    setEmails([]);
  };

  const tagRender = (props) => {
    const { label, value, closable, onClose } = props;
    return (
      <Tag color="blue" closable={closable} onClose={onClose} style={{ marginRight: 3 }}>
        {label}
      </Tag>
    );
  };

  const getFilteredOptions = () => {
    return suggestions.filter((email) => {
      const isNotSelected = !emails.includes(email);
      const matchesSearch = !searchValue || email.toLowerCase().includes(searchValue.toLowerCase());
      return isNotSelected && matchesSearch;
    });
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Select
        mode="tags"
        showSearch
        searchValue={searchValue}
        onSearch={setSearchValue}
        style={{ width: '100%' }}
        placeholder={placeholder || t('EMAIL_PLACEHOLDER')}
        value={emails}
        onChange={handleEmailChange}
        tagRender={tagRender}
        options={getFilteredOptions().map((email) => ({
          value: email,
          label: email,
        }))}
        filterOption={false}
        notFoundContent={null}
      />
      <Button
        onClick={handleClearAll}
        type="text"
        icon={<FontAwesomeIcon icon={faTrash} />}
        style={{ marginLeft: '8px', color: 'red' }}
        title={t('EMAIL_DELETE_ALL')}
      />
    </div>
  );
};

export default EmailTagsInput;
